<template>
  <el-dialog
    :visible.sync="isOpen"
    :show-close="true"
    class="egl-dialog-elm channel-dialog"
    :title="$locale('shop.inventoryFluctuation')"
    width="660"
    :close-on-click-modal="false"
  >
      <el-form class="commercial-inventory-form" :model="form" ref="inventoryForm" :rules="formRules">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item
              :label="$locale('shop.currentlyInStock')"
              v-if="tableList.length > 0"
              prop="id"
              :rules="{
                required: true,
                message: this.$locale('form.plsSelectTtemOrOption'),
              }"
            >
              <el-table :data="tableList" class="egl-table">
                <el-table-column label="" width="50">
                  <template slot-scope="scope">
                    <i
                      :class="form.id == scope.row.id ? 'icon-circle act' : 'icon-circle'"
                      @click="chooseRow(scope.row.id)"
                      tabindex="0"
                      hidefocus="true"
                    ></i>
                  </template>
                </el-table-column>

                <el-table-column
                  :label="`${this.$locale('global.item')} / ${this.$locale('global.option')}`"
                  prop="name"
                  min-width="150"
                ></el-table-column>
                <el-table-column :label="$locale('shop.stockQuantity')" prop="num" min-width="60"></el-table-column>
                <el-table-column :label="$locale('global.unit')" prop="unit" min-width="60"></el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$locale('global.type')" class="type-item" prop="inventoryChangeType">
              <el-select v-model="form.inventoryChangeType">
                <el-option
                  v-for="item in inventoryChangeTypeOption"
                  :label="item.label"
                  :value="item.value"
                  :key="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$locale('shop.fluctuationNum')" prop="inventoryChangeQty">
              <el-input v-model="form.inventoryChangeQty" :placeholder="$locale('global.example') + '+100 / -10'" @change="qtyFormat"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$locale('global.remarks')" prop="inventoryChangeSupplement">
              <el-input
                v-model="form.inventoryChangeSupplement"
                type="textarea"
                :placeholder="$locale('global.example') + $locale('shop.inventoryReplenishment')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item class="form-date" :label="$locale('shop.processingDate')" prop="processingDate">
              <el-date-picker
                type="date"
                v-model="form.processingDate"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="dialog-btn">
        <el-button class="egl-btn-white" @click="colse_fn">{{ $locale("global.cancel") }}</el-button>
        <el-button class="egl-btn-yellow" @click="save_fn">{{ $locale("global.confirm") }}</el-button>
      </div>
  </el-dialog>
</template>

<script>
// import RuleTest from "@/utils/simpleRule.js";
// import { dateFormat } from "../../utils/common";
import inventoryChangeQtyValidator from "@/utils/inventoryChangeQtyValidator";
import { decimal2 } from "@/utils/utils";

export default {
  name: "CommercialInventoryDialog",
  data() {
    return {
      visible: false,
      form: {
        id: "",
        inventoryChangeType: "",
        inventoryChangeQty: "",
        inventoryChangeSupplement: "",
        processingDate: this.$moment().valueOf(),
      },
      inventoryChangeTypeOption: [
        {
          label: this.$locale("global.getGoods"),
          value: "getGoods",
        },
        {
          label: this.$locale("global.sale"),
          value: "sellGoods",
        },
        {
          label: this.$locale("global.refound"),
          value: "refoundGoods",
        },
        {
          label: this.$locale("global.discard"),
          value: "discardGoods",
        },
        {
          label: this.$locale("global.other"),
          value: "otherGoods",
        }
      ],
      formRules: {
        inventoryChangeType: [ {
          required: true,
          message: this.$locale("form.plsSelectAType"),
          trigger: "change",
        } ],
        inventoryChangeQty: [
          {
            required: true,
            message: this.$locale("shop.plsEnterNumOfFluctuations"),
            trigger: "blur",
          },
          {
            validator: inventoryChangeQtyValidator,
            trigger: "blur",
          }
        ],
      },
    };
  },
  methods: {
    colse_fn() {
      this.$emit("closeFn");
    },
    save_fn() {
      this.$refs.inventoryForm.validate(valid => {
        if (valid) {
          let data = { ...this.form };
          data.inventoryChangeQty = decimal2(parseFloat(data.inventoryChangeQty).toString())
          data.processingDate = this.$moment(data.processingDate).startOf("day").add(12, "hours").valueOf();
          this.$emit("returnMsg", data);
        } else {
          setTimeout(() => {
            const isError = document.getElementsByClassName("is-error");
            if (isError[0].querySelector("input")) {
              isError[0].querySelector("input").focus();
            } else {
              isError[0].querySelector("i").focus();
            }
          }, 100);

          return false;
        }
      });
    },
    chooseRow(id) {
      if (id) {
        this.form = { ...this.form, id };
        this.$refs.inventoryForm.clearValidate("id");
      }
    },
    qtyFormat(str) {
      if (str.indexOf("+") > -1 || str.indexOf("-") > -1) {
        const sign = str.substr(0, 1)
        const number = decimal2(str.substr(1))
        this.form.inventoryChangeQty = sign + number
      }
    }
  },
  mounted() {},
  props: {
    action: {
      type: String,
      default: "",
    },
    tableList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    isOpen: {
      get() {
        return this.visible;
      },
      set() {
        this.colse_fn();
      }
    }
  },
  watch: {
    action() {
      let visible = false;
      let form = {
        id: "",
        inventoryChangeType: "",
        inventoryChangeQty: "",
        inventoryChangeSupplement: "",
        processingDate: this.$moment().valueOf(),
      };

      if (this.action != "") {
        visible = true;
      } else {
        visible = false;
      }

      this.form = form;
      if (this.$refs.inventoryForm) {
        this.$refs.inventoryForm.resetFields();
      }
      this.visible = visible;
    },
  },
};
</script>
